import FlipCountdown from '@rumess/react-flip-countdown';

import '../../../../assets/css/FlipperClock.css'

function FlipperClock({ boardEndTime }) {

    // const timeUp = () => {
    //     setScoreFlag(false);
    //     setClockFlag(false);
    // };



    return (
        <FlipCountdown
            size='extra-small'
            theme='dark'
            endAt={boardEndTime}
            // onTimeUp={timeUp}
            hourTitle=''
            minuteTitle=''
            secondTitle=''
            hideYear
            hideMonth
            hideDay
        />
    );

}

export default FlipperClock;